import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import { renameFolder } from '~/generated/sdk.gen';
import { extractData } from '~/utils/query-utils';

type RenameFolderParams = {
  folderId: string;
  newName: string;
};

export const useRenameFolder = (
  options: UseMutationOptions<
    unknown,
    unknown,
    RenameFolderParams,
    unknown
  > = {}
) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ folderId, newName }: RenameFolderParams) => {
      return extractData(
        renameFolder({ path: { folderId, folderName: newName } })
      );
    },
    ...options,
    onSuccess(data, variables, mutationResult, context) {
      queryClient.invalidateQueries({ queryKey: ['document-share'] });
      options.onSuccess?.(data, variables, mutationResult, context);
    },
  });
};
